// import { toast } from 'react-toastify';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import Dropzone from 'react-dropzone';

import Button from '@/components/Button';
import GeneralLoading from '@/components/GeneralLoading';

interface PreviewProps {
  meta: any;
  deleteFile: (index: number) => void;
}

const DropzoneImgs = ({
  setFile,
  type,
}: {
  setFile: (file: File | null) => void;
  type: string;
}) => {
  // const [loading, setLoading] = useState(false);
  const [fileAccepted, setFileAccepted] = useState<File | null>(null);
  const loading = false;
  const handleFilesAccepted = (newFile: File) => {
    setFileAccepted(newFile);
    setFile(newFile);
  };

  const deleteFile = () => {
    setFileAccepted(null);
    setFile(null);
  };

  return (
    <>
      <div style={{ marginTop: '1rem' }}>
        {loading ? (
          <GeneralLoading size={100} text="Cargando" withDots fontVariant="h5" />
        ) : (
          <Dropzone
            onDrop={(acceptedFiles) => handleFilesAccepted(acceptedFiles[0])} // Aca es donde se reciben los archivos que se suben, el formato es "File[]", osea un array de File
            accept={{ 'file/*': [type] }} // Formatos aceptados
            // onDropAccepted={() => setDropAccepted(true)} // Aca se ejecuta la funcion que se encarga de subir los archivos
          >
            {({ getRootProps, getInputProps }) => (
              <section>
                {fileAccepted ? (
                  <Preview meta={fileAccepted} deleteFile={deleteFile} />
                ) : (
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <InputContent />
                  </div>
                )}
              </section>
            )}
          </Dropzone>
        )}
      </div>
    </>
  );
};

export default DropzoneImgs;

const InputContent = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px dashed',
        borderColor: theme.palette.grey[500],
        padding: '1rem',
        borderRadius: '0.5rem',
        gap: '0.5rem',
        backgroundColor: theme.palette.grey[50],
        cursor: 'pointer',
      }}
    >
      <Button variant="outlined" startIcon={<UploadFileIcon color="primary" />}>
        ¡Selecciona tu archivo aquí!
      </Button>
      <Typography variant="body2" color={theme.palette.secondary.main}>
        O arrastra tu archivo aquí
      </Typography>
    </Box>
  );
};

const Preview = ({ meta, deleteFile }: PreviewProps) => {
  const theme = useTheme();
  const { size, name } = meta;
  const formatBytes = (bytes: number) => {
    const units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let l = 0;
    let number = bytes;

    while (number >= 1024) {
      number /= 1024;
      l += 1;
    }

    return `${number.toFixed(number >= 10 || l < 1 ? 0 : 1)}${units[l]}`;
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px dashed',
        borderColor: theme.palette.primary.main,
        padding: '1rem',
        borderRadius: '0.5rem',
        gap: '0.5rem',
        backgroundColor: theme.palette.grey[50],
        cursor: 'pointer',
      }}
    >
      <UploadFileIcon color="primary" />
      <Typography>
        {name} - {formatBytes(size)}
      </Typography>
      <Grid
        container
        spacing={1}
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Button
          //   endIcon={<DeleteOutlineIcon color="error" />}
          onClick={deleteFile}
          size="small"
          variant="outlined"
        >
          Cancelar
        </Button>
      </Grid>
    </Box>
  );
};
